import {
  defaultShouldDehydrateQuery,
  QueryClient,
  QueryClientProvider
} from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5 // 5 minutes
    },
    dehydrate: {
      shouldDehydrateQuery: query =>
        defaultShouldDehydrateQuery(query) || query.state.status === 'pending',
      shouldRedactErrors: () => {
        return false
      }
    }
  }
})

export function getContext() {
  return {
    queryClient,
    profile: null,
    isAuthenticated: false
  }
}

export function Provider({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  )
}
